module.exports = __webpack_public_path__ + "static/media/Buildingnew.d359093b.svg";